import React from "react";
import { useParams } from "react-router-dom";
import useGames from "../../hooks/queryResults/useGames";
import useIsLoading from "../../hooks/queryResults/useIsLoading";
import useTeam from "../../hooks/queryResults/useTeam";
import useWeek from "../../hooks/queryResults/useWeek";
import GameSummary from "../game/GameSummary";
import WeekLinks from "../nav/WeekLinks";
import Loading from "../ui/Loading";
import TeamBanner from "./TeamBanner";
import TeamLineup from "./TeamLineup";

const TeamLineupPage = () => {
  const { league: leagueUrl, season } = useParams();
  const { team, teamsQuery } = useTeam();
  const { selectedWeek } = useWeek();
  const { gamesCollection } = useGames(selectedWeek);

  const isLoading = useIsLoading(team, teamsQuery, gamesCollection);
  if (isLoading) return <Loading />;

  const teamGames = gamesCollection.getGamesByTeam(team.obj.id);
  let teamGame = null;
  if (teamGames) {
    teamGame = teamGames[selectedWeek] || null;
  }
  const gameSummary = (
    <div style={{ margin: "-0.25rem 0 0 1rem" }}>
      {teamGame ? (
        <GameSummary game={teamGame} size={"lg"} />
      ) : (
        "No game scheduled"
      )}
    </div>
  );

  return (
    <div>
      <div style={{ marginBottom: "1rem" }}>
        <TeamBanner team={team} />
      </div>
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "1rem" }}
      >
        {/*<h2>Lineup</h2>*/}
        <WeekLinks
          path={`/${leagueUrl}/${season}/${team.idOrSlug}/lineup/:week`}
        />
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div style={{ maxWidth: "36rem" }}>
          <TeamLineup team={team} />
        </div>
        {gameSummary}
      </div>
    </div>
  );
};

export default TeamLineupPage;
